declare var swal: any;
import { Component, OnInit } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../models/appdata';
import { IsSessionExistsRequest } from '../../../../models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../services/login.service';
import { ApiResponseModel } from '../../../../models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';
import { SpinnerService } from '../../../../services/spinner.service';


declare var require: any;


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbMyScheduleModal } from '../myschedulemodal/myschedule.modal';
import { JobApplicationsInfoByRegistryRequest, JobApplicationsInfoByRegistryOnDemandController, SaveShiftStatusRequest } from '../../../../models/hcare/hcare.model';
import { HcareService } from '../../../../services/hcare.service';
import { Pipe } from '@angular/core';
import { Injectable } from '@angular/core';
import { PipeTransform } from '@angular/core';


@Pipe({
  name: 'JobApplicationsInfoPipe'
})

@Injectable()
export class JobApplicationsInfoPipe implements PipeTransform {

  transform(value: JobApplicationsInfoByRegistryOnDemandController[], filter: string): JobApplicationsInfoByRegistryOnDemandController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: JobApplicationsInfoByRegistryOnDemandController) =>
      app.CareUnitName != null && app.CareUnitName.toLocaleLowerCase().indexOf(filter) != -1
      || app.ApplicationStatus != null && app.ApplicationStatus.toLocaleLowerCase().indexOf(filter) != -1
      || app.HospitalDisplayName != null && app.HospitalDisplayName.toLocaleLowerCase().indexOf(filter) != -1
      || app.Department != null && app.Department.toLocaleLowerCase().indexOf(filter) != -1
      || app.JobCode != null && app.JobCode.toString().toLocaleLowerCase().indexOf(filter) != -1
      || app.Specialty != null && app.Specialty.toLocaleLowerCase().indexOf(filter) != -1
      || app.ShiftType != null && app.ShiftType.toLocaleLowerCase().indexOf(filter) != -1
      || app.StaffType != null && app.StaffType.toLocaleLowerCase().indexOf(filter) != -1
      || app.StaffType != null && app.StaffType.toLocaleLowerCase().indexOf(filter) != -1
    ) : value;
  }

}


import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SearchComponent } from '../../../../custumcomponents/search/search.component';
import { CodeTypeValueComponent } from '../../../../custumcomponents/codetypes/codetypevalue.component';

@Component({
  selector: 'myschedulemanager',
  templateUrl: './myschedulemanager.component.html',
  animations: [routerTransition()]
})

export class MyScheduleManagerComponent implements OnInit {
  GetActorIdentitiesController() { }
  searchTitle: string="";
  public ActorCode: number = 0;
  public selectedMonth: string;
  public SelectFromDate: Date;
  public SelectToDate: Date;

  public isRequesting: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;


  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;


  sub: Subscription;


  public MaxDateV = new Date();
  public MinDateV = new Date();


  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  SelectedToDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  TodayDate = new Date();

  //public SelectFromDate: Date;
  //public SelectToDate: Date;

  ngOnInit() {
  

    this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() -1, day: this.TodayDate.getDate() };


    this.SelectFromDate = new Date(this.parserFormatter.format(this.SelectedFromDate))
    this.SelectToDate = new Date(this.parserFormatter.format(this.SelectedToDate))




    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();

    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    this.CurrentJobApplicationsInfoByRegistryOnDemandController = new Array<JobApplicationsInfoByRegistryOnDemandController>();
    this.CurrentJobApplicationsInfoByRegistryRequest = new JobApplicationsInfoByRegistryRequest();
    this.CurrentJobApplicationsInfoByRegistryRequest.ConditionalOperator = 10;
    this.CurrentJobApplicationsInfoByRegistryRequest.NurseActorCode = this.ActorCode;
    this.CurrentJobApplicationsInfoByRegistryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentJobApplicationsInfoByRegistryRequest.RegistryActorCode = AppData.Instance().UserLoginDetails.FacilityActorCode;
    this.CurrentJobApplicationsInfoByRegistryRequest.StartIndex = 0;
    this.CurrentJobApplicationsInfoByRegistryRequest.EndIndex = this.RecordsOnDemand;
    this.AppendJobApplicationsInfoByRegistryOnDemandController = new Array<JobApplicationsInfoByRegistryOnDemandController>();
    this.pdata = this.AppendJobApplicationsInfoByRegistryOnDemandController;
    this.GetJobApplicationsInfoByRegistryOnDemandController();
  }

  Refresh() {
    this.GetDataByLocationAndDuration();
    //this.GetJobApplicationsInfoByRegistryOnDemandController();
  }
  // For Search
  pdata: any[];// = this.data;
  listFilter: string;
  sort: any = {
    column: 'JoinByDate',
    descending: false
  };
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.AppendJobApplicationsInfoByRegistryOnDemandController,
          this.listFilter);
      }
    }
  }

  //ngOnChanges(changes: any) {
  //  if (JSON.stringify(changes).indexOf("data") != -1)
  //    this.pdata = this.AppendJobApplicationsInfoByRegistryOnDemandController;
  //  this.criteriaChange(this.listFilter);
  //}
  FilterDataByStatus() {
    this.criteriaChange(this.SelectedStatusFilter);
  }

  GetDataByLocationAndDuration() {
    this.CurrentJobApplicationsInfoByRegistryOnDemandController = new Array<JobApplicationsInfoByRegistryOnDemandController>();
    this.CurrentJobApplicationsInfoByRegistryRequest = new JobApplicationsInfoByRegistryRequest();
    //this.CurrentJobApplicationsInfoByRegistryRequest.ConditionalOperator = 20;
    this.CurrentJobApplicationsInfoByRegistryRequest.NurseActorCode = this.ActorCode;
    this.CurrentJobApplicationsInfoByRegistryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentJobApplicationsInfoByRegistryRequest.RegistryActorCode = AppData.Instance().UserLoginDetails.FacilityActorCode;
    this.CurrentJobApplicationsInfoByRegistryRequest.StartIndex = 0;
    this.CurrentJobApplicationsInfoByRegistryRequest.EndIndex = this.RecordsOnDemand;
    this.AppendJobApplicationsInfoByRegistryOnDemandController = new Array<JobApplicationsInfoByRegistryOnDemandController>();
    this.pdata = this.AppendJobApplicationsInfoByRegistryOnDemandController;
    this.GetJobApplicationsInfoByRegistryOnDemandController_();
  }


  public LastRowNo: number = 0;
  public LRowNo: number = 0;
  public RecordsOnDemand: number = 500;
  public SelectedLocationCode: number;
  public SelectedLocationName: string ='';
  onSelectedLocationChange(event: any) {

    if (event != null) {

      this.SelectedLocationName = event;
      this.GetDataByLocationAndDuration();


    }
  }

  SelectedStatusFilter: string;
  onSelectedStatusChange(event: any) {

    if (event != null) {
      //alert(event);
      //this.SelectedLocationName = event;
      this.FilterDataByStatus();


    }
  }
  AcceptShiftRequest(req: any) {



  }
  RejectShiftRequest(req: any) {



  }
  FillClockInOut(req: any) {



  }
  SwitchRequest(req: any) {



  }
  dataChanged(newObj) {
    this.GetDataByLocationAndDuration();
  }
  GetJobApplicationsInfoByRegistryOnDemandController_() {

    this.StartRefreshing();
    this.CurrentJobApplicationsInfoByRegistryRequest.ConditionalOperator = 20;
    this.CurrentJobApplicationsInfoByRegistryRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate))
    this.CurrentJobApplicationsInfoByRegistryRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));

    this.CurrentJobApplicationsInfoByRegistryRequest.Location = this.SelectedLocationName;

    this.hcareservice.GetJobApplicationsInfoByRegistryOnDemandController(this.CurrentJobApplicationsInfoByRegistryRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentJobApplicationsInfoByRegistryOnDemandController = this.ApiResData.Result;
          this.AppendJobApplicationsInfoByRegistryOnDemandController = new Array<JobApplicationsInfoByRegistryOnDemandController>();
          //  console.log('this.CurrentRegistryNursesInfoOnDemandController.length--->' + this.CurrentRegistryNursesInfoOnDemandController.length);
          if (this.CurrentJobApplicationsInfoByRegistryOnDemandController.length > 0) {
            for (let append of this.CurrentJobApplicationsInfoByRegistryOnDemandController) {
              if ((append.RowNo) > this.LastRowNo) {
                this.LastRowNo = append.RowNo;
                this.CurrentJobApplicationsInfoByRegistryRequest.StartIndex = append.RowNo;

              }
              this.AppendJobApplicationsInfoByRegistryOnDemandController.push(append);


            }
            this.pdata = this.AppendJobApplicationsInfoByRegistryOnDemandController;
          }


          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
 
  GetJobApplicationsInfoByRegistryOnDemandController() {
    
    this.StartRefreshing();
    this.hcareservice.GetJobApplicationsInfoByRegistryOnDemandController(this.CurrentJobApplicationsInfoByRegistryRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentJobApplicationsInfoByRegistryOnDemandController = this.ApiResData.Result;
          this.AppendJobApplicationsInfoByRegistryOnDemandController = new Array<JobApplicationsInfoByRegistryOnDemandController>();
          //  console.log('this.CurrentRegistryNursesInfoOnDemandController.length--->' + this.CurrentRegistryNursesInfoOnDemandController.length);
          if (this.CurrentJobApplicationsInfoByRegistryOnDemandController.length > 0) {
            for (let append of this.CurrentJobApplicationsInfoByRegistryOnDemandController) {
              if ((append.RowNo) > this.LastRowNo) {
                this.LastRowNo = append.RowNo;
                this.CurrentJobApplicationsInfoByRegistryRequest.StartIndex = append.RowNo;

              }
              this.AppendJobApplicationsInfoByRegistryOnDemandController.push(append);
              

            }
            this.pdata = this.AppendJobApplicationsInfoByRegistryOnDemandController;
          }


          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  selectedClass(columnName: string): any {
    return columnName == this.sort.column ? 'sort-' + this.sort.descending : false;
  }

  changeSorting(columnName: string): void {
    var sort = this.sort;
    if (sort.column == columnName) {
      sort.descending = !sort.descending;
    } else {
      sort.column = columnName;
      sort.descending = false;
    }
   // this.sort = sort;
  }

  convertSorting(): string {
    //alert(this.sort);
    //return "";
    return this.sort.descending ? '-' + this.sort.column : this.sort.column;
  }
  CurrentJobApplicationsInfoByRegistryRequest: JobApplicationsInfoByRegistryRequest;
  CurrentJobApplicationsInfoByRegistryOnDemandController: JobApplicationsInfoByRegistryOnDemandController[];
  AppendJobApplicationsInfoByRegistryOnDemandController: JobApplicationsInfoByRegistryOnDemandController[];
  constructor(private router: Router,
    private hcareservice: HcareService,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private filter: JobApplicationsInfoPipe,
    private loginservice: LoginService,
    private parserFormatter: NgbDateParserFormatter) { }



  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  openScheduleAssistant(l: Date) {
    //l.JoinByDate
    //alert("...");
    const modalRef = this.modalService.open(NgbMyScheduleModal,
      {
        centered: true,
        size: "lg"
      })
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.componentInstance.TodayDate = l;
    modalRef.result.then(x => { this.GetActorIdentitiesController() })

  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  GetShiftStatus(l: any) {

    if (!l.NurseResponse && !l.HospitalResponse) {
      return "";
    }

    if (l.NurseResponse == 'Accepted' && l.HospitalResponse == 'Accepted')
      return "Shift Confirmed";
    if (l.NurseResponse == 'Accepted' && !l.HospitalResponse)
      return "Waiting for Hospital Acceptance";
    if (l.NurseResponse == 'Accepted' && l.HospitalResponse == 'Rejected')
      return "Unavailable(Hospital)";
    if (l.NurseResponse == 'Rejected')
      return "Unavailable(Self)";
    return "";

  }


  RaiseAcceptRequest(l: any) {
    var data: JobApplicationsInfoByRegistryOnDemandController = l;

    //alert(data);

    //alert("in RaiseAcceptRequest");
    var request: SaveShiftStatusRequest = new SaveShiftStatusRequest();
    request.ConditionalOperator = 10;  

    request.HospitalActorCode = l.HospitalActorCode;
    request.NurseActorCode = this.ActorCode;
    request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    request.ShiftAllocationCode = l.JobApplicationCode;
    request.Status = "Accepted";

    //alert(request.ShiftAllocationCode);
    this.StartRefreshing();


    this.hcareservice.SaveShiftStatus(request)
      
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            alertFunctions.AlertParam('Saved Successfully.....!');
            this.GetDataByLocationAndDuration();
            this.stopRefreshing();
            this.GetJobApplicationsInfoByRegistryOnDemandController_();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("--- Invalid Operation...!" + this.ApiResData.ErrorData);


            this.stopRefreshing();
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            this.stopRefreshing();
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
    
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
      
          this.stopRefreshing();
        }
      }
      );

  }

  RaiseRejectRequest(l: any) {

    var request: SaveShiftStatusRequest = new SaveShiftStatusRequest();
    request.ConditionalOperator = 20;

    request.HospitalActorCode = l.HospitalActorCode;
    request.NurseActorCode = this.ActorCode;
    request.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    request.ShiftAllocationCode = l.JobApplicationCode;
    request.Status = "Rejected";

    this.StartRefreshing();


    this.hcareservice.SaveShiftStatus(request)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            alertFunctions.AlertParam('Saved Successfully.....!');
            this.GetDataByLocationAndDuration();
            this.stopRefreshing();
            this.GetJobApplicationsInfoByRegistryOnDemandController_();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("--- Invalid Operation...!" + this.ApiResData.ErrorData);


            this.stopRefreshing();
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            this.stopRefreshing();
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );
  }




}





